/**
 * A single tappable card used by the multi-select screens (household,
 * professionals). Shows an icon, a label, and a teal check-circle when
 * selected. Tap the whole card to toggle.
 */
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { ms, s } from '../../../utils/responsive';

type Props = {
  label: string;
  description?: string;
  selected: boolean;
  onToggle: () => void;
  icon?: any;
};

export const WizardCheckOption: React.FC<Props> = ({
  label,
  description,
  selected,
  onToggle,
  icon,
}) => {
  return (
    <TouchableOpacity
      style={[styles.card, selected && styles.cardSelected]}
      onPress={onToggle}
      accessibilityRole="checkbox"
      accessibilityState={{ checked: selected }}
      accessibilityLabel={label}
      activeOpacity={0.7}
    >
      <View style={styles.contentRow}>
        {icon ? <Image source={icon} style={styles.icon} /> : null}
        <View style={styles.textColumn}>
          <Text style={styles.label}>{label}</Text>
          {description ? <Text style={styles.description}>{description}</Text> : null}
        </View>
        <View style={[styles.checkCircle, selected && styles.checkCircleSelected]}>
          {selected ? <Text style={styles.checkMark}>✓</Text> : null}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: ms(16),
    padding: ms(16),
    borderWidth: ms(2),
    borderColor: '#E1E5EA',
    marginBottom: ms(12),
  },
  cardSelected: {
    borderColor: '#29BFC0',
    backgroundColor: '#F0FBFB',
  },
  contentRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    marginRight: ms(12),
  },
  textColumn: {
    flex: 1,
  },
  label: {
    fontSize: ms(16, 0.3),
    fontWeight: '600',
    color: '#1C2C4F',
  },
  description: {
    fontSize: ms(13, 0.3),
    color: '#6B7280',
    marginTop: ms(2),
  },
  checkCircle: {
    width: s(26),
    height: s(26),
    borderRadius: s(13),
    borderWidth: ms(2),
    borderColor: '#E1E5EA',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkCircleSelected: {
    backgroundColor: '#29BFC0',
    borderColor: '#29BFC0',
  },
  checkMark: {
    color: '#FFFFFF',
    fontSize: ms(14, 0.3),
    fontWeight: 'bold',
  },
});
